import {Injectable} from '@angular/core';

import {StorageService} from './abstract-storage.service';

@Injectable()
export class LocalStorageService extends StorageService {
    constructor() {
        super(window.localStorage || window.sessionStorage || {});
        window.addEventListener('storage', (e: StorageEvent) => {
            if (e.key) {
                this._changeEmitter.emit({ key: e.key, value: e.newValue });
            }
        });
    }
}